"use client";

import React from "react";
import { Marquee } from "@/components/ui/marquee";

interface JourneySocialProofProps {
  heading: string;
  mediaLogos: Array<{
    name: string;
    logo: string;
  }>;
}

const JourneySocialProof = ({ heading, mediaLogos }: JourneySocialProofProps) => {
  return (
    <section className="py-12 bg-white border-y border-zinc-100">
      <div className="container max-w-6xl mx-auto">
        <p className="text-center text-[10px] font-bold tracking-widest text-zinc-400 uppercase mb-8">
          {heading}
        </p>
        <Marquee pauseOnHover className="[--duration:30s] [--gap:3rem]">
          {mediaLogos.map((media) => (
            <div
              key={media.name}
              className="flex items-center justify-center px-8"
            >
              <span className="text-xl md:text-2xl font-black tracking-tight text-zinc-300 hover:text-zinc-500 transition-colors cursor-default">
                {media.logo}
              </span>
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default JourneySocialProof;
